/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Outlook_Reconnect_SuccessInputs */



/**
* | output |
* | --- |
* | "Outlook permissions upgraded successfully." |
*
* @param {Spaces_Outlook_Reconnect_SuccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_outlook_reconnect_success = /** @type {((inputs?: Spaces_Outlook_Reconnect_SuccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Outlook_Reconnect_SuccessInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Outlook-Berechtigungen erfolgreich aktualisiert.")
	return /** @type {LocalizedString} */ ("Outlook permissions upgraded successfully.")
});